import React from "react";
import {hydrateRoot} from "react-dom/client";
import {Site} from "./app.jsx";

const rootEl=document.getElementById("root");
const initialRoute=rootEl.dataset.route||"home";
hydrateRoot(rootEl, <Site initialRoute={initialRoute}/>);
